import type { Economics } from 'src/services/IntentService';

export const rubles = (value: string | number | null | undefined) =>
    value === null || value === undefined
        ? 'Нет данных'
        : new Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB', maximumFractionDigits: 2 }).format(
              Number(value)
          );

export function optionalNumber(value: unknown): number | null {
    if (value === '' || value === null || value === undefined || typeof value === 'boolean') return null;
    const number = Number(value);
    return Number.isFinite(number) && number >= 0 ? number : null;
}

export function calculateEconomics(input: Economics, count = 0, leadCost = 0, handling = 0) {
    const gain = optionalNumber(input.contribution);
    const percent = optionalNumber(input.conversion);
    const other = optionalNumber(input.other);
    if (gain === null || percent === null || percent > 100) return null;
    const value = (gain * percent) / 100;
    const sales = (count * percent) / 100;
    const cost = leadCost + handling + (other || 0);
    return {
        value,
        sales,
        cost,
        result: count ? count * value - cost : null,
        costPerCustomer: sales > 0 ? cost / sales : null,
        maxLeadPrice: count > 0 ? value - (handling + (other || 0)) / count : null,
        breakEvenConversion: count > 0 && gain > 0 ? (100 * cost) / (count * gain) : null,
        otherKnown: other !== null,
    };
}

export function validBudget(value: string) {
    return /^\d+(\.\d{1,2})?$/.test(value) && Number(value) >= 1500 && Number(value) <= 1000000;
}

export function safeExternalUrl(value: string | null | undefined): string | undefined {
    try {
        const url = new URL(value || '');
        return ['https:', 'http:'].includes(url.protocol) && !url.username && !url.password ? url.href : undefined;
    } catch {
        return undefined;
    }
}
